/**
 * El ancho del chat lateral, a gusto del autor (Rais, 24-sep: «es difícil de leer»). Se arrastra el
 * borde izquierdo del chat; el ancho se recuerda en este navegador, y si no se puede guardar vale
 * el de por defecto.
 */
import { useState } from "react";

const CLAVE = "hi.anchoChat";
const POR_DEFECTO = 520;

export function useAnchoChat() {
  const [ancho, setAncho] = useState<number>(() => {
    try { const n = Number(localStorage.getItem(CLAVE)); return n >= 360 ? n : POR_DEFECTO; } catch { return POR_DEFECTO; }
  });
  return { ancho, setAncho, estilo: { ["--ancho-chat" as string]: `${ancho}px` } };
}

export default function BordeChat({ ancho, setAncho }: { ancho: number; setAncho: (n: number) => void }) {
  const arrastrar = (e: React.PointerEvent) => {
    e.preventDefault();
    const tope = (x: number) => Math.round(Math.max(360, Math.min(x, window.innerWidth - 720)));
    let ultimo = ancho;
    const mover = (ev: PointerEvent) => { ultimo = tope(window.innerWidth - ev.clientX); setAncho(ultimo); };
    const soltar = () => {
      window.removeEventListener("pointermove", mover); window.removeEventListener("pointerup", soltar);
      try { localStorage.setItem(CLAVE, String(ultimo)); } catch { /* sin almacenamiento: no se recuerda */ }
    };
    window.addEventListener("pointermove", mover); window.addEventListener("pointerup", soltar);
  };
  return <div className="chat-borde" onPointerDown={arrastrar} role="separator" aria-orientation="vertical"
              aria-label="Ancho del chat: arrastra para cambiarlo" title="Arrastra para ensanchar el chat" />;
}
